const ROLE_ALIASES = {
  user: 'client',
  manager: 'hoster',
  admin: 'admin',
  client: 'client',
  hoster: 'hoster',
  super_admin: 'super_admin'
};

export const normalizeRole = (role) => {
  if (!role) return null;
  return ROLE_ALIASES[role] || null;
};

// Возвращает локализованный лейбл роли. Если t не передан -- возвращает технический ключ.
export const getRoleLabel = (role, t, options = {}) => {
  const normalized = normalizeRole(role);
  if (!normalized) return role || '';
  if (typeof t !== 'function') return normalized;
  const key = normalized === 'super_admin' ? 'roles.superAdmin' : `roles.${normalized}`;
  return t(key, { ns: 'common', defaultValue: normalized, ...options });
};

export const isClient = (role) => normalizeRole(role) === 'client';
export const isHoster = (role) => normalizeRole(role) === 'hoster';
export const isAdmin = (role) => normalizeRole(role) === 'admin';
export const isAdminOrSuperAdmin = (role) => {
  const n = normalizeRole(role);
  return n === 'admin' || n === 'super_admin';
};
export const isHosterOrAbove = (role) => {
  const n = normalizeRole(role);
  return n === 'hoster' || n === 'admin' || n === 'super_admin';
};

// Список ролей для селекта назначения. super_admin сюда не входит -- назначается вручную через SQL.
export const ASSIGNABLE_ROLES = ['client', 'hoster', 'admin'];
